import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import {
  buildMemberFilterGroups,
  buildMemberApiFilters,
  memberColumns,
  memberReportBaseConfig,
  renderMemberCell,
} from '../constants/membershipReportShared';

const GROWTH_COLUMNS = memberColumns([
  { id: 'movement', label: 'Movement', defaultVisible: true, sortable: false },
  { id: 'lapsed_on', label: 'Lapsed', defaultVisible: true, sortable: true, sortType: 'date' },
]);

const MOVEMENT_FILTER = {
  id: 'movement',
  label: 'Movement',
  type: 'checkbox',
  options: [
    { value: 'joined', label: 'Joined' },
    { value: 'lapsed', label: 'Lapsed' },
  ],
};

const countCard = (label, current, prior, key) => ({
  label,
  value: (current[key] || 0).toLocaleString(),
  current: current[key] || 0,
  prior: prior?.[key],
});

const GROWTH_CONFIG = {
  ...memberReportBaseConfig({
    slug: 'growth',
    title: 'Growth & Retention',
    sidebarKey: 'memberships_growth',
    localStorageName: 'reportingMembershipsGrowthColumns',
  }),
  pageSubtitle: 'Members gained and lost over the period, and how many of the members you started with you kept.',
  showDatePicker: true,
  dateModeOptions: [{ key: 'movement_date', label: 'Movement Date' }],
  detailTableTitle: 'Joined & Lapsed Members',
  columns: GROWTH_COLUMNS.columns,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: GROWTH_COLUMNS.getDefaultVisibleColumns,
  getDefaultHiddenColumns: GROWTH_COLUMNS.getDefaultHiddenColumns,
  defaultSortRules: [],
  emptyMessage: 'No members joined or lapsed in this period.',

  buildFilterGroups: (venueOwnerships) => buildMemberFilterGroups({
    venueOwnerships, extraFilters: [MOVEMENT_FILTER],
  }),
  buildDetailApiFilters: buildMemberApiFilters(null, ['movement']),

  buildKpiCards: (current, prior) => [
    countCard('New Members', current, prior, 'new_members'),
    { label: 'Lost Members', value: (current.lost_members || 0).toLocaleString() },
    {
      label: 'Net Change',
      value: `${(current.net_change || 0) > 0 ? '+' : ''}${(current.net_change || 0).toLocaleString()}`,
      current: current.net_change || 0,
      prior: prior?.net_change,
    },
    {
      label: 'Retention Rate',
      value: `${(current.retention_rate || 0).toFixed(1)}%`,
      current: current.retention_rate || 0,
      prior: prior?.retention_rate,
    },
  ],

  salesCardTitle: 'Active Members',
  salesCardIsCurrency: false,
  buildMetricValue: (d) => (d.ending_members || 0).toLocaleString(),
  buildMetricLabel: (d) => `${(d.starting_members || 0).toLocaleString()} at start of period`,
  overTimeKey: 'over_time',
  countLabel: 'members',
  chartColor: 'var(--sl-fg-brand, #1982C4)',

  renderCellValue: renderMemberCell(['lapsed_on']),
};

function ReportingMembershipsGrowthPage(props) {
  return <SalesDetailPage {...props} config={GROWTH_CONFIG} />;
}

export default ReportingMembershipsGrowthPage;
